module.exports = __webpack_public_path__ + "img/ai-model-bg.d871518b.jpg";